import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import z from "zod";

import { getDatasourceFileUrl } from "@/core/lib/api";
import { fetchDatasourcesByIds } from "@/core/lib/datasources-by-ids";

const searchSchema = z.object({
  referenceDatasourceId: z.uuid(),
  reviewDatasourceId: z.uuid(),
});

export const Route = createFileRoute(
  "/_protected/document-analysis/comparison",
)({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ context: { queryClient, ...context }, deps }) => {
    const orgId = context.user.organization?.id;
    if (!orgId) {
      throw redirect({ to: "/no-organization", throw: true });
    }

    const datasources = await fetchDatasourcesByIds(queryClient, orgId, [
      deps.referenceDatasourceId,
      deps.reviewDatasourceId,
    ]);

    const reference = datasources.find(
      (d) => d.id === deps.referenceDatasourceId,
    );
    const review = datasources.find((d) => d.id === deps.reviewDatasourceId);
    if (!reference || !review) {
      throw notFound();
    }

    return {
      referenceName: reference.name,
      reviewName: review.name,
      referencePdfUrl: getDatasourceFileUrl(reference) ?? "",
      reviewPdfUrl: getDatasourceFileUrl(review) ?? "",
    };
  },
});
